import DataConst from 'consts/DataConst';
import BaseController from './BaseController';

class ImportOrderController extends BaseController {
  model = DataConst.MODELS.IMPORT_ORDER;
}

export default new ImportOrderController();
